<div class="lidl-lib-cart-fe-icon">
    <ng-container *ngIf="cartItemsAmount > 99; else elseTemplate">
        <div class="numberCircle">99+</div>
    </ng-container>
    <ng-template #elseTemplate>
        <div *ngIf="cartItemsAmount" class="numberCircle" id="cartNumber">{{cartItemsAmount}}</div>
    </ng-template>
    <svg id="icon" class="cart-icon">
        <use xlink:href="assets/images/sprite_icons.svg#Lidl_giftcard_Icons-svg3"></use>
    </svg>
    <span>
        <ng-content></ng-content>
    </span>
</div>
